export default __webpack_public_path__ + "static/media/activitylog.e7bb3d69.svg";